import { Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "./components/Shell";
import { Home } from "./pages/Home";
import { Explore } from "./pages/Explore";
import { Catchments } from "./pages/Catchments";
import { SystemRecord } from "./pages/SystemRecord";
import { Models } from "./pages/Models";
import { ModelRecord } from "./pages/ModelRecord";
import { Studies } from "./pages/Studies";
import { StudyRecord } from "./pages/StudyRecord";
import { Events } from "./pages/Events";
import { EventRecord } from "./pages/EventRecord";
import { Assumptions } from "./pages/Assumptions";
import { Insights } from "./pages/Insights";
import { SearchPage } from "./pages/Search";
import { Compare } from "./pages/Compare";
import { Workspace } from "./pages/Workspace";
import { About, Concept, DataPage, Methodology } from "./pages/StaticPages";

export function App() {
  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/catchments" element={<Catchments />} />
        <Route path="/system/:slug" element={<SystemRecord />} />
        <Route path="/models" element={<Models />} />
        <Route path="/model/:slug" element={<ModelRecord />} />
        <Route path="/studies" element={<Studies />} />
        <Route path="/study/:slug" element={<StudyRecord />} />
        <Route path="/events" element={<Events />} />
        <Route path="/event/:slug" element={<EventRecord />} />
        <Route path="/assumptions" element={<Assumptions />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/about" element={<About />} />
        <Route path="/methodology" element={<Methodology />} />
        <Route path="/data" element={<DataPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/workspace" element={<Workspace />} />
        <Route path="/workspace/:tab" element={<Workspace />} />
        <Route path="/admin" element={<Navigate to="/workspace/sources" replace />} />
        <Route path="/concepts/:slug" element={<Concept />} />
      </Route>
    </Routes>
  );
}
